import { html } from "@microsoft/fast-element";
import { SvgIcon } from "./svg-icon.js";
/**
 * Generates the template for the {@link @fabric-msft/fabric-web#SvgIcon} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure for the `SvgIcon` component.
 *
 * @returns {ElementViewTemplate<SvgIcon>} The template for the `SvgIcon` component.
 */
export const template = html `
  <template></template>
`;
//# sourceMappingURL=svg-icon.template.js.map